<template>
	<div class="tour">
		
		<bg-music :music="tour.music" ref="bg-music"></bg-music>
		<div id="pano" style="width:100%;height:100%;"></div>
		<div class="tours">
			<span
				v-for="(item, index) in tours"
				:key="index"
				:class="'item-' + item.scenes.length + ' ' + (item.id == tourId ? 'active' : '')"
				@click="changeTour(item.id)"
				v-show="item.scenes.length > 0"
			>
				{{ item.title }}
				<small v-if="item.scenes.length == 0">建设中</small>
			</span>
		</div>
		<div class="tools">
			<img v-if="hasGyroscope && isGyro" src="../assets/images/gyroscope.png" @click="gyroOp" alt="" />
			<img v-if="hasGyroscope && !isGyro" src="../assets/images/gyroscope-off.png" @click="gyroOp" alt="" />
			<img v-if="isPlay" src="../assets/images/sound.png" @click="musicOp" alt="" />
			<img v-else-if="tour.music" src="../assets/images/sound-off.png" @click="musicOp" alt="" />
		</div>
		<div class="scenes" v-show="showScenes">
			<div class="flex" :class="scenes.length < 4 ? 'justify-around' : ''">
				<div class="item" v-for="(item, index) in scenes" :key="index" :class="sceneName == item.name ? 'active' : ''" @click="changeScene(item.name)">
					<img :src="item.pano_path + '/thumb.jpg'" alt="" />
					<span>{{ item.title }}</span>
				</div>
			</div>
		</div>
		<dialog-page v-for="(page, index) in pages" :key="index" :title="page.title" @close="close">
			<template v-if="page.type == 'category'">
				<dialog-page-category :category="page.id" @detail="onDetail" @update-title="setTitle"></dialog-page-category>
			</template>
			<template v-else-if="page.type == 'books'">
				<dialog-page-books :books="page.data" @detail="onDetail"></dialog-page-books>
			</template>
			<template v-else-if="page.type == 'book'">
				<dialog-page-book :book="page.data"></dialog-page-book>
			</template>
			<template v-else-if="page.type == 'type'">
				type
			</template>
			<template v-else-if="page.type == 'faces'">
				<dialog-page-faces :faces="page.data" @detail="onDetail"></dialog-page-faces>
			</template>
			<template v-else-if="page.type == 'face'">
				<dialog-page-face :face="page.data"></dialog-page-face>
			</template>
			<template v-else>
				<dialog-page-article :article="page.data"></dialog-page-article>
			</template>
		</dialog-page>

		<media ref="media" @close="mediaClose"></media>
		
		<curtain-up ref="curtain"></curtain-up>
		<!-- <transition name="curtain" v-on:afterEnter="curtainUp"><div class="curtain-up" v-if="curtain"></div></transition> -->
	</div>
</template>

<script>
// KrPano 交互对象
class PanoState {
	scene = '';
	info = '';
	values = {};
	showInfo(info) {
		console.log('showInfo', info);
		this.info = info;
	}
	updateScene(scene) {
		console.log('updateScene', scene);
		this.scene = scene;
	}
	setValue(key, value) {
		this.values = {};
		this.values[key] = value;
	}
}
import CurtainUp from '../components/CurtainUp.vue';
import BgMusic from '../components/BgMusic.vue';
import DialogPage from '../components/DialogPage.vue';
import DialogPageArticle from '../components/DialogPageArticle.vue';
import DialogPageCategory from '../components/DialogPageCategory.vue';
import DialogPageFaces from '../components/DialogPageFaces.vue';
import DialogPageFace from '../components/DialogPageFace.vue';
import DialogPageBooks from '../components/DialogPageBooks.vue';
import DialogPageBook from '../components/DialogPageBook.vue';
import Media from '../components/Media.vue';
import { mapGetters } from 'vuex';
export default {
	components: {
		CurtainUp,
		BgMusic,
		DialogPage,
		DialogPageArticle,
		DialogPageCategory,
		DialogPageFaces,
		DialogPageFace,
		DialogPageBooks,
		DialogPageBook,
		Media
	},
	computed: {
		...mapGetters(['isPlay']),
		hasGyroscope() {
			return window.DeviceOrientationEvent;
		},
		isGyro() {
			if (this.pano) {
				return this.state.values['gyro'] == 'true';
			}
			return false;
		}
	},
	watch: {
		tour(newVal, oldVal) {
			if (newVal && newVal.title) {
				document.title = newVal.title;
			}
		},
		'state.scene'(newVal, oldVal) {
			if (newVal != this.sceneName) {
				this.sceneName = newVal;
				// this.scene = this.scenes.find((item) => {
				// 	return item.name == this.sceneName;
				// })
			}
		},
		'state.info'(newVal, oldVal) {
			if (newVal && newVal != oldVal) {
				var params = {};
				newVal.split('|').forEach(item => {
					let [key, value] = item.split(':');
					params[key] = value;
				});
				if (params.face) {
					this.openFaces(params.page_category);
				} else if (params.book) {
					this.openBooks(params.page_category);
				} else if (params.page_category) {
					this.openCategory(params.page_category);
				} else if (params.page) {
					this.openArticle(params.page);
				}
			}
		},
		'state.values'(newVal, oldVal) {}
	},
	data() {
		return {
			state: new PanoState(),
			pano: null,
			tourId: 0,
			sceneName: '',
			tour: {},
			tours: [],
			scenes: [],
			scene: '',
			pages: [],
			bgStatus: false,
			count: 0,
			curtain: false,
			showScenes: false,
		};
	},
	methods: {
		curtainUp(el, done) {
			console.log('/////')
			this.curtain = false;
			//done();
		},
		musicOp() {
			this.$refs['bg-music'].switch();
		},
		gyroOp() {
			this.pano.call('switch_gyro()');
		},
		close() {
			this.state.info = '';
			this.pages.pop();
		},
		setTitle(title) {
			this.$set(this.pages[this.pages.length - 1], 'title', title);
		},
		changeTour(tourId) {
			if (tourId == this.tourId) {
				return;
			}
			let tour = this.tours.find(item => {
				return item.id == tourId;
			});
			if (!tour || tour.scenes.length === 0) {
				return this.$alert('建设中，尽情期待');
			}
			this.tour = tour;
			this.tourId = tourId;
			this.scenes = this.tour.scenes;
			this.sceneName = this.scenes[0].name;
			let xmlname = process.env.VUE_APP_PANO_DOMAIN + '/api/svc/vr/tours/' + this.tourId + '/xml';
			this.pano.call('loadpano(' + xmlname + ', null, MERGE, BLEND(0.5));');
			this.pano.call("loadscene('" + this.sceneName + "')");
		},
		changeScene(scene) {
			console.log('changeScene');
			this.sceneName = scene;
			this.pano.call("loadscene('" + scene + "')");
		},
		getTours() {
			return this.$api.get('/api/svc/vr/tours', {
				enabled: 1
			});
		},
		catchHander(err) {
			this.$loading.hide();
			this.$alert(err.message);
		},
		openArticle(id) {
			this.$loading.show();
			this.$api.page
				.getDetail(id)
				.then(res => {
					this.$loading.hide();
					this.pages.push({ type: 'article', title: res.title, data: res });
				})
				.catch(this.catchHander);
		},
		openBooks(id) {
			this.$loading.show();
			this.$api
				.get('/api/svc/cms/page/articles', {
					type_id: 4,
					category_id: id
				})
				.then(res => {
					this.$loading.hide();
					this.pages.push({
						type: 'books',
						title: '书籍',
						data: res
					});
				})
				.catch(this.catchHander);
		},
		openBook(id, data = {}) {
			this.$loading.show();
			this.$api.page
				.getDetail(id)
				.then(res => {
					this.$loading.hide();
					this.pages.push({
						type: 'book',
						title: data.title,
						data: res
					});
				})
				.catch(this.catchHander);
		},
		openFaces(id) {
			this.$loading.show();
			this.$api
				.get('/api/svc/cms/page/articles', {
					type_id: 5,
					category_id: id
				})
				.then(res => {
					this.$loading.hide();
					this.pages.push({
						type: 'faces',
						title: '脸谱',
						data: res
					});
				})
				.catch(this.catchHander);
		},
		openFace(id, data = {}) {
			var push = data => {
				this.pages.push({
					type: 'face',
					title: data.title,
					data: data
				});
			};
			if (data == {}) {
				this.$loading.show();
				this.$api.page
					.getDetail(id)
					.then(res => {
						this.$loading.hide();
						push(res);
					})
					.catch(this.catchHander);
			} else {
				push(data);
			}
		},
		openCategory(id, query = '') {
			this.pages.push({
				type: 'category',
				id: id
			});
		},
		openMedio(id, data) {
			this.bgStatus = this.isPlay;
			if (this.bgStatus) {
				this.musicOp();
			}
			if (data.type_id == 7) {
				this.$refs['media'].open(data.video, 'video', data.image);
			} else if (data.type_id == 3) {
				this.$refs['media'].open(data.audio, 'audio', data.image);
			}
		},
		onDetail(e) {
			if (e.type == 'face') {
				this.openFace(e.id, e.data);
			} else if (e.type == 'book') {
				this.openBook(e.id, e.data);
			} else if (e.type == 'media') {
				this.openMedio(e.id, e.data);
			} else {
				//people,document, or other..
				this.openArticle(e.id, e.data);
			}
		},
		mediaClose() {
			if (this.bgStatus) {
				this.musicOp();
			}
		}
	},

	mounted() {
		var that = this,
			domain = process.env.VUE_APP_PANO_DOMAIN;
		window.PanoState = this.state;
		let tourName = this.$route.query.tour;
		let sceneName = this.$route.query.startscene;

		if ((!tourName && !sceneName) || (tourName == 'F2' && !sceneName) || (tourName == 'F2' && sceneName == 'xuting')) {
			this.$refs['curtain'].begin();
			//this.curtain = true;
		}

		this.getTours()
			.then(res => {
				this.tours = res;
				this.tour = tourName
					? this.tours.find(item => {
							return item.name == tourName;
					  }) || this.tours[0]
					: this.tours[0];
				this.tourId = this.tour.id;
				this.scenes = this.tour.scenes;
				this.scene = sceneName
					? this.scenes.find(item => {
							return item.name == sceneName;
					  }) || this.scenes[0]
					: this.scenes[0];
				this.sceneName = this.scene.name;
				console.log(this.tourId, this.sceneName);
				return {
					tour: this.tour.id,
					scene: this.sceneName
				};
			})
			.then(res => {
				
				this.$refs['bg-music'].play();
				embedpano({
					basepath: domain + '/assets/svc/vtour/',
					//swf: domain + '/assets/svc/vtour/tour.swf',
					xml: domain + '/api/svc/vr/tours/' + res.tour + '/xml?v=2',
					target: 'pano',
					html5: 'auto',
					mobilescale: 1.0,
					passQueryParameters: true,
					//startscene: res.scene,
					onready: () => {
						this.showScenes = true;
						console.log('tour is onready');
						//this.$loading.hide();
						that.pano = document.getElementById('krpanoSWFObject');
					},
					onerror: err => {
						//this.$loading.hide();
						this.$alert(err.message);
					}
				});
			})
			.catch(err => {
				//this.$loading.hide();
				this.$alert(err.message);
			});
	}
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/sprite';

// @-webkit-keyframes curtain-up {
// 	@for $i from 0 through 122 {
// 		//@if $i%2 > 0 {
// 			#{$i/122*100}% {
// 				$url: '';
// 				@if $i < 10 {
// 					$url: '../assets/images/curtain-up/mu000#{$i}';
// 				} @else if $i<100 {
// 					$url: '../assets/images/curtain-up/mu00#{$i}';
// 				} @else {
// 					$url: '../assets/images/curtain-up/mu0#{$i}';
// 				}
// 				$url: '#{$url}.png';
// 				// @if $i <= 35 {
// 				// 	$url: '#{$url}.jpg';
// 				// } @else {
// 				// 	$url: '#{$url}.png';
// 				// }
// 				background-image: url(#{$url});
// 			}
// 		//}
// 	}
// }
// .curtain-enter-active {
// 	animation: curtain-up 10s 1;
// }
// .curtain-up {
// 	position: fixed; 
// 	top: 0;
// 	left: 0;
// 	right: 0;
// 	bottom: 0;
// 	z-index: 9999999999 !important;
// 	background-position: center center;
// 	background-repeat: no-repeat;
// 	background-size: 100% 100%;
// }

.tour {
	height: 100%;
	width: 100%;
}

.tours {
	position: absolute;
	top: 0.2rem;
	left: 0;
	display: flex;
	flex-direction: column;
	span {
		display: flex;
		flex-direction: column;
		justify-content: center;
		height: 0.72rem;
		padding-left: 0.2rem;
		padding-right: 0.3rem;
		border-top-right-radius: 1rem;
		border-bottom-right-radius: 1rem;
		background-color: rgba($color: #15454f, $alpha: 0.7);
		font-size: 0.28rem;
		color: #e9c45c;
		margin-bottom: 0.36rem;
		letter-spacing: 0.01rem;
		&.item-0 {
			font-size: 0.24rem;
		}
		&.active {
			display: none;
			position: relative;
			background-color: rgba($color: #15454f, $alpha: 0.9);
			&::after {
				// position: absolute;
				// content: '';
				// bottom: 0;
				// top: 0;
				// right: -0.6rem;
				// width: 0.5rem;
				// background: url(../assets/images/tour-active.png) no-repeat center center;
				// background-size: 0.45rem;
			}
		}
		small {
			font-weight: lighter;
			margin-top: -0.04rem;
			display: block;
			color: #e9c45c;
			font-size: 0.16rem;
			letter-spacing: 0;
		}
	}
}

.tools {
	position: absolute;
	top: 0.2rem;
	right: 0.2rem;
	height: 0.6rem;
	display: flex;
	justify-content: flex-end;
	z-index: 9;
	img {
		margin-left: 0.3rem;
		opacity: 0.6;
		width: 0.6rem;
		height: 0.6rem;
	}
}

.scenes {
	position: absolute;
	bottom: 0.2rem;
	padding: 0.15rem;
	left: 0rem;
	right: 0rem;
	height: 1.5rem;
	overflow: auto hidden;
	background-color: rgba($color: #000000, $alpha: 0.6);
	box-sizing: border-box;
	.item {
		width: 1.7rem;
		min-width: 1.7rem;
		height: 1.2rem;
		position: relative;
		margin-left: 0.05rem;
		margin-right: 0.05rem;
		border: #d9d9d9 solid 0.02rem;
		img {
			width: 100%;
			height: 100%;
		}
		span {
			position: absolute;
			bottom: 0;
			left: 0;
			right: 0;
			text-align: center;
			color: #fff;
			font-size: 0.24rem;
		}
		&::after {
			position: absolute;
			content: '';
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: rgba($color: #000000, $alpha: 0.4);
		}
		&.active {
			border-color: #fff;
			&::after {
				background: none;
			}
		}
	}
}
.mu0000 {
}
</style>
